import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    flex: {
      display: 'flex',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    status: {
      textTransform: 'uppercase',
      // not available in material-ui, should we add it?
      fontSize: '0.625rem',
      fontWeight: 500,
      borderRadius: '16px',
      padding: theme.spacing(0, 1),
      marginLeft: theme.spacing(),
    },
    statusNew: {
      backgroundColor: '#9E9E9E',
      color: theme.palette.common.white,
    },
    statusInProgress: {
      backgroundColor: '#FDD835',
      color: theme.palette.common.black,
    },
    statusCompleted: {
      backgroundColor: '#43A047',
      color: theme.palette.common.white,
    },
    dueDateSoon: {
      color: theme.palette.warning.main,
    },
    dueDatePast: {
      color: theme.palette.error.main,
    },
  };
};
